var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3188 11.1084C15.6588 11.1084 15.9888 11.1484 16.3188 11.1984V6.1084L10.3188 0.108398H2.31885C1.20885 0.108398 0.318848 0.998398 0.318848 2.1084V18.1084C0.318848 19.2184 1.20885 20.1084 2.31885 20.1084H10.1288C9.61885 19.2284 9.31885 18.2084 9.31885 17.1084C9.31885 13.7984 12.0088 11.1084 15.3188 11.1084ZM9.31885 1.6084L14.8188 7.1084H9.31885V1.6084ZM16.3188 17.6084V16.1084H12.3188V14.1084H16.3188V12.6084L19.3188 15.1084L16.3188 17.6084ZM14.3188 18.1084H18.3188V20.1084H14.3188V21.6084L11.3188 19.1084L14.3188 16.6084V18.1084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transferIcon.e5480229e089696dd36fe7112bf8898b.svg";
export { ForwardRef as ReactComponent };